module.exports = __webpack_public_path__ + "img/glocal-add.ed9bbca3.png";